var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11494 13.0034C2.56075 13.6192 1.61232 13.6691 0.996553 13.1149C0.380788 12.5608 0.33087 11.6123 0.885059 10.9966L3.11494 13.0034ZM11 2L9.88506 0.996552C10.1648 0.685712 10.5616 0.505771 10.9798 0.500135C11.3979 0.494501 11.7995 0.663686 12.0875 0.966875L11 2ZM21.5875 10.9669C22.1581 11.5675 22.1337 12.5169 21.5331 13.0875C20.9325 13.6581 19.9831 13.6337 19.4125 13.0331L21.5875 10.9669ZM0.885059 10.9966L9.88506 0.996552L12.1149 3.00345L3.11494 13.0034L0.885059 10.9966ZM12.0875 0.966875L21.5875 10.9669L19.4125 13.0331L9.9125 3.03312L12.0875 0.966875Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.2d2ed30d9fd82ad1876b9f65e7260dbd.svg";
export { ForwardRef as ReactComponent };